<template>
  <span class="header-title">Calculate your estimated DaaS costs</span>
</template>
<script>
export default {
  name: 'HeaderName',
};
</script>

<style scoped>
.header-title {
  font-size: 40px;
  line-height: 46px;
  font-weight: 300;
}

@media (max-width: 768px) {
  .header-title {
    font-size: 29px;
    line-height: 33px;
    font-weight: 300;
  }
}
</style>
